import { DatePicker } from './datePicker';

function onDocumentReady() {
  'use strict';

  const selectors = {
    self: 'cmp-form-text.date',
  };

  const datepickers = document.querySelectorAll(`.${selectors.self}`);

  if (datepickers && datepickers.length > 0) {
    datepickers.forEach((datepickers) => {
      const options = datepickers as HTMLElement;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const _datePickerObj = new DatePicker(options);
    });
  }

  const MutationObserver =
    window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
  const body = document.querySelector('body');
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      // needed for IE
      const nodesArray = Array.from(mutation.addedNodes) as HTMLElement[];
      if (nodesArray.length > 0) {
        nodesArray.forEach(function (addedNode) {
          if (addedNode instanceof HTMLElement) {
            const elementsArray = Array.from(addedNode.querySelectorAll(`.${selectors.self}`));
            elementsArray.forEach((element) => {
              const datePicker = new DatePicker(element as HTMLElement);
              datePicker.init();
            });
          }
        });
      }
    });
  });

  if (body) {
    observer.observe(body, {
      subtree: true,
      childList: true,
      characterData: true,
    });
  }
}

(function () {
  if (document.readyState !== 'loading') {
    onDocumentReady();
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady);
  }
})();
